import { Link } from '@tanstack/react-router';
import { FileText } from 'lucide-react';
import { Card, CardTitle, EmptyState } from '@wundo/ui';
import type { SkillRecentUsage } from '@wundo/shared/skillStats.ts';
import { formatDate } from '@/utils/dateUtils.ts';

const DATE: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
};

/** Who has this skill loaded, most recently used first. */
export function SkillRecentUsers({ recent }: { recent: SkillRecentUsage[] }) {
  return (
    <Card as='section' aria-label='Recent users'>
      <CardTitle as='h3'>Recent users ({recent.length})</CardTitle>

      {recent.length === 0 ? (
        <EmptyState title='No users yet' />
      ) : (
        <ul className='mt-3.5 flex flex-col'>
          {recent.map((entry) => (
            <li
              key={entry.user_id}
              className='flex items-center justify-between gap-2 border-t border-line py-2 first:border-t-0'
            >
              <div className='min-w-0'>
                {/* The skills tab, because that is the question this list raises. */}
                <Link
                  to='/users/$id'
                  params={{ id: entry.user_id }}
                  hash='skills'
                  className='text-sm font-semibold text-ink'
                >
                  {entry.user_name ?? entry.user_id.slice(0, 8)}
                </Link>
                <div className='text-xs text-ink-muted'>
                  {entry.last_used_at ? formatDate(entry.last_used_at, DATE) : 'never'}
                </div>
              </div>
              {entry.has_notes && (
                <span className='flex shrink-0 items-center gap-1 text-xs text-ink-muted'>
                  <FileText className='size-3' aria-hidden='true' /> notes
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
